import {Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {BaseComponent, ConfirmComponent, FeatureFlagService, PusherService, Shared, UserService} from '@rubii/frontend-common';
import {ConfigService} from '../../services/config.service';
import {ItemResponse} from '@rubii/frontend-common/lib/models/common/Response';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {User} from '@rubii/frontend-common/lib/models/account/User';
import {ForgetComponent} from '../../password/forget/forget.component';
import {ActivatedRoute, Router} from '@angular/router';
import { UserEmailNotification } from '../interfaces/user-email-notification.interface';
import { WsEvent } from '@rubii/frontend-common/lib/models/events/ws-event.class';
import * as moment from 'moment-timezone';
import { EditUserComponent } from '../edit-user/edit-user.component';
import { ClientService } from '../../services/client.service';
import { NotificationPreference } from '@rubii/entity/src/mdb-entities/notifications';
import { NotificationCategories, NotificationCategory } from '@rubii/sdk-web-notification/src/types';
import { OtpVerificationDialogComponent } from './otp-verification-dialog/otp-verification-dialog.component';
import { VerifyMobileResponse } from '@rubii/sdk-web-user/src/types';
import { OtpStateService } from './otp-state.service';
import { Subscription } from 'rxjs';
import { TwoFactorEvents, twoFAFeatureId } from '../../verification/two-factor-verification.constants';

interface CountryCodeNode {
    value: string;
    children: Map<string, CountryCodeNode>;
    isCountryCode?: boolean;
    countryData?: { code: string; flag: string };
}

@Component({
    selector: 'app-setting',
    templateUrl: './setting.component.html',
    styleUrls: ['./setting.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SettingComponent extends BaseComponent implements OnInit, OnDestroy {

    search: FormControl;
    shared = Shared;
    adminFilterOn: boolean;
    traderFilterOn: boolean;
    AMFilterOn: boolean;
    dialogRef = null;
    isLocked = false;

    user: User;
    
    countryCodeTree: CountryCodeNode;
    allCountryCodes: { code: string; flag: string }[];

    roles: any[];

    searchTime: any = null;

    firstname: FormControl;

    lastname: FormControl;

    email: FormControl;

    mobileNumber: FormControl;

    countryCode: FormControl;

    authPreference: FormControl;

    userKeyword = '';

    users: any[] = [];

    selectedIndex = 0;
    selectedAiTabIndex = 0;

    newUser: any = null;

    newUserFormGroup: FormGroup;

    roleError = false;

    isUserAdded = false;

    userEmailNotifications: UserEmailNotification[];
    notificationCategories: NotificationCategory[] = NotificationCategories;

    commentsNotifications: {category: NotificationCategory, disabled: boolean}[];

    tabs = [
        'me',
        'custom-fields',
    ];

    aiTabs = ['ai-chatbot', 'ai-prompt', 'ai-agents', 'ai-tools', 'ai-tool-executions'];

    verifyButtonDisabled = false;
    verifyButtonTimer = 0;
    verifyTimerInterval: any;
    verifyTimerMinutesValue = 0;

    twoFaFeatureOn = false;


    private otpStateSub: Subscription | null = null;
    private smsLastAttemptCookieKey = 'smsLastAttempt';
    // getLastLogin(timestamp) {
    //     let date = new Date(timestamp*1000);
    //     const tmp = date.toString().split(" ");
    //     return tmp[2] + " " + tmp[1] + " " + tmp[3];
    // }

    constructor(private config: ConfigService,
        public userService: UserService,
        private client: ClientService,
        private snack: MatSnackBar,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private router: Router,
        private pusher: PusherService,
        private otpStateService: OtpStateService,
        private feature: FeatureFlagService) {
        super();
        pusher.bind(Shared.dicts.PushChannels.user.name, Shared.dicts.PushChannels.user.events.created, this.userAdded.bind(this));
        pusher.bind(Shared.dicts.PushChannels.user.name, Shared.dicts.PushChannels.user.events.updated, this.userUpdated.bind(this));
        this.user = userService.user;
        console.log('user: ', this.user);
        
        this.initializeCountryCodes();
        this.buildCountryCodeTree();

        const temp = userService.user.name.split(' ');
        this.firstname = new FormControl(temp[0], [Validators.required]);
        this.lastname = new FormControl(temp[1], [Validators.required]);
        this.email = new FormControl(userService.user.email, []);
        
        this.mobileNumber = new FormControl(this.user.mobile?.split('-').pop() || '', []);
        this.countryCode = new FormControl(this.user.mobile?.split('-').shift() || '+61', []);

        this.authPreference = new FormControl((userService.user as any).authPreference || 'email', []);
        

        this.newUserFormGroup = new FormGroup({
            firstname: new FormControl('', [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(45)
            ]),
            lastname: new FormControl('', [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(45)
            ]),
            email: new FormControl('', [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(100),
                Validators.email
            ])
        });
        this.roles = [];

    }

    async ngOnInit() {
        let that = this;
        this.tabs = [
            'me',
            'custom-fields',
        ];
        if (this.userService.isAdmin) {
            this.tabs.push('users');
            this.tabs.push('tenant');
        }
        this.tabs.push('notifications');
        this.tabs.push('ai');
        this.client.user.isLocked(this.user.email).then(res => {
            this.isLocked = res;
            if (this.isLocked) {
                this.router.navigate(['/lock']);
                // this.userService.logoff();
            }
        });
        
        this.route.queryParams
            .subscribe(async params => {
                if (params.state || params.code || params.type || params.tab === 'datasource') {
                    this.router.navigate(['/datasources'], {queryParams: params, queryParamsHandling: 'merge'});
                    return ;
                }
                let tab = params.tab;
                let subTab = params['sub-tab'];
                
                if (tab === 'custom-fields') {
                    that.selectedIndex = this.tabs.indexOf('custom-fields');
                    document.title = 'Custom Metrics | Rubii - Digital Media Trading';
                } else if (tab === 'users' && this.userService.isAdmin) {
                    that.selectedIndex = this.tabs.indexOf('users');
                    document.title = 'Users | Rubii - Digital Media Trading';
                    this.twoFaFeatureOn = false;
                    await this.checkTwoFactorEnabled();
                } else if (tab === 'tenant' && this.userService.isAdmin) {
                    that.selectedIndex = this.tabs.indexOf('tenant');
                    document.title = 'Tenant Settings | Rubii - Digital Media Trading';
                } else if (tab === 'notifications') {
                    that.selectedIndex = this.tabs.indexOf('notifications');
                    document.title = 'Notifications | Rubii - Digital Media Trading';
                } else if (tab === 'ai') {
                    that.selectedIndex = this.tabs.indexOf('ai');
                    document.title = 'AI Settings | Rubii - Digital Media Trading';
                    if (subTab) {
                        that.selectedAiTabIndex = this.aiTabs.indexOf(subTab);
                    } else {
                        // Default to AI Agents tab (index 1) when no sub-tab is specified
                        that.selectedAiTabIndex = 1;
                        // Update URL to include sub-tab
                        this.router.navigate([], {
                            queryParams: { tab: 'ai', 'sub-tab': 'ai-agents' },
                            queryParamsHandling: 'merge'
                        });
                    }
                } else {
                    that.selectedIndex = this.tabs.indexOf('me');
                    document.title = 'My Profile | Rubii - Digital Media Trading';
                    if(!tab) {
                        this.router.navigate([], {queryParams: {tab: 'me'}, queryParamsHandling: 'merge'});
                    }
                }
                this.initTabContents();
            });

        this.otpStateSub = this.otpStateService.state$.subscribe(state => {
            const pausedUntil = state?.pausedUntil || 0;
            const now = Date.now();
            if (pausedUntil && pausedUntil > now) {
                this.verifyButtonDisabled = true;
                const remaining = Math.ceil((pausedUntil - now) / 1000);
                if (this.verifyTimerInterval) {
                    clearInterval(this.verifyTimerInterval);
                    this.verifyTimerInterval = null;
                }
                this.verifyButtonTimer = remaining;
                this.verifyTimerMinutesValue = Math.ceil(this.verifyButtonTimer / 60);
                this.verifyTimerInterval = setInterval(() => {
                    this.verifyButtonTimer--;
                    this.verifyTimerMinutesValue = Math.ceil(this.verifyButtonTimer / 60);
                    if (this.verifyButtonTimer <= 0) {
                        this.resetVerifyTimer();
                        try { this.otpStateService.clearState(); } catch (e) {}
                    }
                }, 1000);
            } else {
                this.resetVerifyTimer();
            }
        });


    }

    handleInlineRoleChange(selectedRole, user) {
        if (selectedRole && selectedRole.id !== Shared.dicts.UserRoles.ADMIN) {
            const editUser = JSON.parse(JSON.stringify(user));
            editUser.roles = [selectedRole.id];
            this.editUser(editUser);
        } else {
            const temp = user.name.split(' ');
            const input = {
                firstname: temp[0],
                lastname: temp[1],
                userId: user.id,
                roles: [selectedRole.id],
                includeServiceFee: null,
                advertisers: [],
                agencies: []
            };
            this.client.user.editUser(input).then(res => this.editUserCallback({result: true, data: res} as ItemResponse)).catch(e => this.editUserCallback({result: false, text: e.message} as ItemResponse));
        }
    }

    editUser(user) {
        let dialogRef = this.dialog.open(EditUserComponent, {
            width: '344px',
            data: user,
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe((data) => {
            if (!data) {
                return;
            }
            this.client.user.editUser({...data, userId: user.id}).then(res => this.editUserCallback({result: true, data: res} as ItemResponse)).catch(e => this.editUserCallback({result: false, text: e.message} as ItemResponse));
        });
    }

    addNewUser() {
        let dialogRef = this.dialog.open(EditUserComponent, {
            width: '344px',
            disableClose: true,
            data: {
            },
        });
        dialogRef.afterClosed().subscribe((data) => {
            if (!data) {
                return;
            }
            this.client.user.invite(data).then(res => this.newUserCallback({result: true, data: res} as ItemResponse)).catch(e => this.newUserCallback({result: false, text: e.message} as ItemResponse));
        });
    }

    userAdded(event: WsEvent) {
        if (this.selectedIndex === this.tabs.indexOf('users')) {
            this.isUserAdded = true;
            if (this.newUser === null) {
                this.initTabContents();
            }
        }
    }

    userUpdated(event: WsEvent) {
        console.log(event);
        const message = event.data;
        if (message.id === this.user.id) {
            let user = JSON.parse(JSON.stringify(this.userService.user));
            user.name = message.firstname + ' ' + message.lastname;
            user.authPreference = message.authPreference || 'email';
            this.userService.user = user;
            this.user = this.userService.user;
            this.firstname.setValue(message.firstname);
            this.lastname.setValue(message.lastname);
            this.authPreference.setValue(message.authPreference || 'email');
        }
        this.initTabContents();
    }

    unlockedUser(user) {
        let dialogRef = this.dialog.open(ConfirmComponent, {
            width: '400px',
            data: {
                title: 'Unlock User',
                subTitle: `Are you sure you want to unlock the user "${user.email}"?`,
                okBtn: { name: 'Yes', value: 'Yes' },
                cancelBtn: { name: 'No', value: 'No' }
            },
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((data) => {
                if (!data || data === 'No') {
                    return;
                }
               this.client.user.unlock(user.email).then(res => {
                    this.openSnackBar(this.snack, 'User unlocked successfully', 'close');
                    this.feature.trigger(twoFAFeatureId, TwoFactorEvents.UserUnlockByAdmin, {useremail: user.email, adminemail: this.user.email});
                    this.getTenantUsers();
                }).catch(e => {
                    this.openSnackBarWarning(this.snack, e.message, 'close');
                });
            });
    }

    getFirstNameErrorMessage() {
        return this.firstname.hasError('required') ? 'You must enter your firstname' : '';
    }

    getLastNameErrorMessage() {
        return this.lastname.hasError('required') ? 'You must enter your lastname' : '';
    }

    async verifyMobile() {
        if (this.mobileNumber.value && /^\d+$/.test(this.mobileNumber.value) && this.countryCode.value && /^\+\d+$/.test(this.countryCode.value)) {
            const otpState = this.otpStateService.getState();
            const now = Date.now();
            if (otpState.pausedUntil && otpState.pausedUntil > now) {
                this.openSnackBarWarning(this.snack, 'OTP verification paused. Please try again after 5 minutes.', 'close');
                return;
            }
            try {
                this.startVerifyTimer();
                const ret = await this.client.user.initiateMobileVerify({
                    countryCode: +this.countryCode.value.replace('+', ''),
                    phoneNumber: +this.mobileNumber.value as any,
                });
                if (ret.result) {
                    Shared.helpers.CookieHelper.setCookie(this.smsLastAttemptCookieKey, JSON.stringify(ret));
                    const mobileWithCode = this.countryCode.value + '-' + this.mobileNumber.value;
                    const dialogRef = this.dialog.open(OtpVerificationDialogComponent, {
                        width: '600px',
                        disableClose: true,
                        data: {
                            mobileNumber: mobileWithCode,
                            onResend: async () => {
                                try {
                                    const ret = await this.client.user.initiateMobileVerify({
                                        countryCode: +this.countryCode.value.replace('+', ''),
                                        phoneNumber: +this.mobileNumber.value as number,
                                    });
                                    if (ret.result) {
                                        Shared.helpers.CookieHelper.setCookie(this.smsLastAttemptCookieKey, JSON.stringify(ret));
                                        this.resetVerifyTimer();
                                        this.startVerifyTimer();
                                        this.openSnackBar(this.snack, 'OTP resent', 'close');
                                    } else {
                                        this.openSnackBarWarning(this.snack, ret.message, 'close');
                                    }
                                } catch (e) {
                                    this.openSnackBarWarning(this.snack, e.message, 'close');
                                }
                            },
                            onSubmit: async (otp: string) => {
                                try {
                                    const result = await this.client.user.verifyMobile({
                                        countryCode: +this.countryCode.value.replace('+', ''),
                                        phoneNumber: +this.mobileNumber.value as any,
                                        verifyCode: +otp
                                    });
                                    if (result && result.result) {
                                        this.otpStateService.setState({ invalidCounter: 0, pausedUntil: 0 });
                                        this.user.mobileVerified = 1;
                                        this.user.mobile = this.countryCode.value + '-' + this.mobileNumber.value;
                                        this.userService.user = this.user;
                                        this.resetVerifyTimer();
                                        this.feature.trigger(twoFAFeatureId, TwoFactorEvents.UserAddedMobile, {useremail: this.user.email, mobile: this.user.mobile});
                                    }
                                    return result;
                                } catch (e) {
                                    return { result: false, message: e?.message || 'Verification failed' } as any;
                                }
                            }
                        }
                    });
                } else {
                    this.openSnackBarWarning(this.snack, ret.message, 'close');
                }
            } catch (e) {
                console.log('initiateMobileVerify error', e);
                this.openSnackBarWarning(this.snack, e.message, 'close');
                this.resetVerifyTimer();
            }
        } else {
            this.openSnackBarWarning(this.snack, 'Please enter a valid country code and phone number', 'close');
        }
    }

    startVerifyTimer() {
        this.verifyButtonDisabled = true;
        const now = Date.now();
        const otpState = this.otpStateService.getState();
        if (otpState && otpState.pausedUntil && otpState.pausedUntil > now) {
            this.verifyButtonTimer = Math.ceil((otpState.pausedUntil - now) / 1000);
        } else {
            const retCookie = Shared.helpers.CookieHelper.getCookie(this.smsLastAttemptCookieKey);
            let remaining = 60;
            if (retCookie) {
                try {
                    const ret: VerifyMobileResponse = JSON.parse(retCookie);
                    let last = ret?.smsLastAttempt || 0;
                    if (last && last < 1e12) {
                        last = last * 1000;
                    }
                    const elapsed = last ? Math.floor((now - last) / 1000) : 0;
                    remaining = Math.max(0, 60 - elapsed);
                } catch (e) {
                    remaining = 60;
                }
            }
            this.verifyButtonTimer = remaining;
        }

        // update minutes value once when timer starts
        this.verifyTimerMinutesValue = Math.ceil(this.verifyButtonTimer / 60);

        if (this.verifyTimerInterval) {
            clearInterval(this.verifyTimerInterval);
            this.verifyTimerInterval = null;
        }
        this.verifyTimerInterval = setInterval(() => {
            this.verifyButtonTimer--;
            this.verifyTimerMinutesValue = Math.ceil(this.verifyButtonTimer / 60);
            if (this.verifyButtonTimer <= 0) {
                this.resetVerifyTimer();
            }
        }, 1000);
    }

    resetVerifyTimer() {
        this.verifyButtonDisabled = false;
        this.verifyButtonTimer = 0;
        this.verifyTimerMinutesValue = 0;
        Shared.helpers.CookieHelper.deleteCookie(this.smsLastAttemptCookieKey);
        if (this.verifyTimerInterval) {
            clearInterval(this.verifyTimerInterval);
            this.verifyTimerInterval = null;
        }
    }

    initTabContents() {
        if (this.selectedIndex === this.tabs.indexOf('users')) {
            this.getTenantUsers();
        } else if(this.selectedIndex === this.tabs.indexOf('notifications')) {
            this.getUserEmailNotifications();
            this.getCommentsNotifications();
        }
    }

    getTenantUsers() {
      
        let roles = [];
        if (this.adminFilterOn) {
            roles.push(Shared.dicts.UserRoles.ADMIN);
        }
        if (this.traderFilterOn) {
            roles.push(Shared.dicts.UserRoles.TRADER);
        }
        if (this.AMFilterOn) {
            roles.push(Shared.dicts.UserRoles.AM);
        }
        this.client.user.list({ pageId: this.page.pageId, pageSize: this.page.pageSize, keyword: encodeURIComponent(this.userKeyword), roles, status: undefined }).then(res => this.getUserCallback({result: true, data: res} as ItemResponse)).catch(e => this.getUserCallback({result: false, text: e.message} as ItemResponse));
    }

    searchUser(value: string) {
        this.userKeyword = value;
        this.getTenantUsers();
    }

    getUserCallback(response: ItemResponse) {
        if (response.result) {
            this.page.total = response.data.total;
            this.users = response.data.data;
            this.users.forEach(user => {
                const roleIds = user.roles.map(role => role.id);
                if (roleIds.includes(Shared.dicts.UserRoles.ADMIN)) {
                    user.canSeeMargin = 1;
                } else if (roleIds.includes(Shared.dicts.UserRoles.EXTERNAL)) {
                    user.canSeeMargin = 0;
                }
            });
            const currenttimezone = moment.tz.guess();
            this.users.forEach((user) => {
                user.lastLogin = user.lastLogin ? moment.tz(+user.lastLogin, currenttimezone).format('DD/MM/YYYY HH:mm:ss z') : user.lastLogin;
            });
        } else {
            this.openSnackBarWarning(this.snack, response.text, 'close');
        }
    }

    updateSelectedIndex(index) {
        let tab = '';
        if (index >= 0 && index < this.tabs.length) {
            tab = this.tabs[index];
        }
        const queryParams: any = { tab };
        
        // Clear sub-tab parameter when switching main tabs
        if (tab !== 'ai') {
            queryParams['sub-tab'] = null;
        }
        
        this.router.navigate(['/settings'], { queryParams });
    }

    updateAiTabIndex(index: number) {
        if (index >= 0 && index < this.aiTabs.length) {
            const subTab = this.aiTabs[index];
            this.selectedAiTabIndex = index;
            this.router.navigate([], {
                queryParams: { tab: 'ai', 'sub-tab': subTab },
                queryParamsHandling: 'merge'
            });
        }
    }

    filterByAdmin() {
        this.adminFilterOn = !this.adminFilterOn;
        this.getTenantUsers();
    }

    filterByTrader() {
        this.traderFilterOn = !this.traderFilterOn;
        this.getTenantUsers();
    }

    filterByAM() {
        this.AMFilterOn = !this.AMFilterOn;
        this.getTenantUsers();
    }

    resetPassword(email) {
        let input = {email: email};
        this.client.user.forgetPassword(input).then(res => this.resetCallback({result: true, data: res} as ItemResponse)).catch(e => this.resetCallback({result: false, text: e.message} as ItemResponse));        
    }

    resetCallback(response: ItemResponse) {
        if (response.result) {
            this.openSnackBar(this.snack, 'An email that contains link to reset password has been sent to this user.', 'close');
        } else {
            this.openSnackBarWarning(this.snack, response.text, 'close');
        }
    }

    getUserActionText(status) {
        if (status === Shared.dicts.UserStatus.WAIT_FOR_CONFIRM) {
            return 'Resend Invite';
        } else {
            return 'Delete User';
        }
    }

    async updateUserStatus(id, email, status) {
        if (status === Shared.dicts.UserStatus.WAIT_FOR_CONFIRM) {
            this.client.user.resendInvite(id).then(res => this.resendCallback({result: true, data: res} as ItemResponse)).catch(e => this.resendCallback({result: false, text: e.message} as ItemResponse));
        } else {
            let dialogSubTitle = 'Are you sure to delete this user?';
            let deleteEnabledDataSources = false;

            const enabledDataSources = await this.client.account.getUserDataSourceDetails(id);
            
            if (enabledDataSources.length) {
                const dspNames = Array.from(new Set(enabledDataSources.map(item => item.dspName)));
                dialogSubTitle = `Are you sure you want to proceed? All data source connections (${dspNames.join(', ')}) associated with this user will also be deleted.`;
                deleteEnabledDataSources = true;
            }

            const dialogRef = this.dialog.open(ConfirmComponent, {
                data: {
                    title: 'Delete User',
                    subTitle: dialogSubTitle,
                    okBtn: { name: 'Yes', value: 'Yes' },
                    cancelBtn: { name: 'No', value: 'No' }
                }
            });

            dialogRef.afterClosed().subscribe((data) => {
                if (!data || data === 'No') {
                    return;
                }
                this.client.user.deleteUser(id, deleteEnabledDataSources).then(res => this.deleteCallback({result: true, data: res} as ItemResponse)).catch(e => this.deleteCallback({result: false, text: e.message} as ItemResponse));
            });
        }
    }

    resendCallback(response: ItemResponse) {
        this.openSnackBar(this.snack, 'Invitation has been resent.', 'close');
    }

    deleteCallback(response: ItemResponse) {
        if (response.result) {
            this.openSnackBar(this.snack, 'User has been deleted', 'close');
            this.getTenantUsers();
        } else {
            this.openSnackBarWarning(this.snack, response.text, 'close');
        }
    }

    addUser() {
        this.newUser = {
            firstname: '',
            lastname: '',
            email: '',
            roles: [],
        };
    }

    addRoleToUser(role_id: number) {
        const exist = this.newUser.roles.some(role => role === role_id);
        console.log(exist);
        if (exist) {
            this.newUser.roles.splice(this.newUser.roles.indexOf(role_id), 1);
        } else {
            this.newUser.roles.push(role_id);
        }
        Shared.helpers.LogHelper.debug(this.newUser);
        this.validaetNewUserRole();
    }

    validaetNewUserRole() {
        if (this.newUser.roles.length === 0) {
            this.roleError = true;
        } else {
            this.roleError = false;
        }
    }

    cancelAddUser() {
        this.newUser = null;
        this.resetFormGroup();
        if (this.isUserAdded) {
            this.isUserAdded = false;
            this.initTabContents();
        }
    }

    resetFormGroup() {
        this.newUserFormGroup.reset();
    }

    editUserCallback(response: ItemResponse) {
        if (response.result) {
            if (response.data && response.data === this.user.id) {
                this.client.user.getUserRolesByTenantUserId(this.user.id).then(res => {
                    this.user.roles = res;
                    this.userService.user = this.user;
                    this.userService.loadUser();
                }).catch(e => console.error(e));
            }
            this.openSnackBar(this.snack, 'Edit Success.', 'close');
        } else {
            this.openSnackBarWarning(this.snack, response.text, 'close');
        }
    }

    newUserCallback(response: ItemResponse) {
        if (response.result) {
            this.getTenantUsers();

            this.openSnackBar(this.snack, 'Invite has been sent to the user.', 'close');
        } else {
            this.openSnackBarWarning(this.snack, response.text, 'close');
        }
    }

    openDialog(): void {
        this.dialogRef = this.dialog.open(ForgetComponent, {});
    }

    hasRole(roleId: number) {
        return this.user.roles.some(role => {
            return role.id === roleId;
        });
    }

    async saveAccount(showSuccessToast: boolean = true) {
        let input = {
            tenantUserId: this.user.id,
            firstName: this.firstname.value,
            lastName: this.lastname.value,
            authPreference: this.authPreference.value,
        };
        if (showSuccessToast) {
            try {
                await this.client.user.updateDetails(input);
                this.openSnackBar(this.snack, 'Changes have been saved', 'close');
            } catch (e) {
                this.openSnackBarWarning(this.snack, e.message, 'close');
            }
        } else {
            await this.client.user.updateDetails(input);
        }
    }

    pageChanged(event) {
        this.page.pageSize = event.pageSize;
        this.page.pageId = event.pageIndex + 1;
        this.getTenantUsers();
    }

    saveUserCallback(response: ItemResponse) {
        if (response.result) {
            let temp = this.userService.user;
            temp.name = this.firstname.value + ' ' + this.lastname.value;
            this.userService.user = temp;
            this.user = temp;

            this.openSnackBar(this.snack, 'Changes have been saved', 'close');
        } else {
            this.openSnackBarWarning(this.snack, response.text, 'close');
        }
    }

    getUserEmailNotifications() {
        this.client.user.getUserEmailNotifications(this.user.id).then(res => {
            this.userEmailNotifications = res;
        }).catch(e => this.openSnackBarWarning(this.snack, e.message, 'close'));
    }

    getCommentsNotifications() {
        this.client.notificationPreference.list().then(res => {
            this.commentsNotifications = this.notificationCategories.map(category => {
                const notification = res.find(item => item.categoryId === category.id);
                return {
                    category,
                    disabled: notification?.disabled || false
                }
            })
        }).catch(e => this.openSnackBarWarning(this.snack, e.message, 'close'));
    }

    updateUserEmailNotifications(userEmailNotification: UserEmailNotification) {
        userEmailNotification.enabled = !userEmailNotification.enabled;
    }

    updateCommentsNotifications(notification: NotificationPreference) {
        notification.disabled = !notification.disabled;
    }

    async saveEmailAndNotificationPreferences() {
        try {
            await this.client.user.updateUserEmailNotifications(this.user.id, this.userEmailNotifications);
            await this.client.notificationPreference.save(this.commentsNotifications.map(item => ({
                categoryId: item.category.id,
                disabled: item.disabled
            })));
            this.initTabContents();
            this.openSnackBar(this.snack, 'Changes have been saved', 'close');
        } catch (e) {
            this.openSnackBarWarning(this.snack, e.message, 'close');
        }
    }

    private initializeCountryCodes() {
        this.allCountryCodes = [
            { code: '+1', flag: '🇺🇸' }, { code: '+1', flag: '🇨🇦' },
            { code: '+7', flag: '🇷🇺' }, { code: '+20', flag: '🇪🇬' },
            { code: '+27', flag: '🇿🇦' }, { code: '+30', flag: '🇬🇷' },
            { code: '+31', flag: '🇳🇱' }, { code: '+32', flag: '🇧🇪' },
            { code: '+33', flag: '🇫🇷' }, { code: '+34', flag: '🇪🇸' },
            { code: '+36', flag: '🇭🇺' }, { code: '+39', flag: '🇮🇹' },
            { code: '+40', flag: '🇷🇴' }, { code: '+41', flag: '🇨🇭' },
            { code: '+43', flag: '🇦🇹' }, { code: '+44', flag: '🇬🇧' },
            { code: '+45', flag: '🇩🇰' }, { code: '+46', flag: '🇸🇪' },
            { code: '+47', flag: '🇳🇴' }, { code: '+48', flag: '🇵🇱' },
            { code: '+49', flag: '🇩🇪' }, { code: '+51', flag: '🇵🇪' },
            { code: '+52', flag: '🇲🇽' }, { code: '+53', flag: '🇨🇺' },
            { code: '+54', flag: '🇦🇷' }, { code: '+55', flag: '🇧🇷' },
            { code: '+56', flag: '🇨🇱' }, { code: '+57', flag: '🇨🇴' },
            { code: '+58', flag: '🇻🇪' }, { code: '+60', flag: '🇲🇾' },
            { code: '+61', flag: '🇦🇺' }, { code: '+62', flag: '🇮🇩' },
            { code: '+63', flag: '🇵🇭' }, { code: '+64', flag: '🇳🇿' },
            { code: '+65', flag: '🇸🇬' }, { code: '+66', flag: '🇹🇭' },
            { code: '+81', flag: '🇯🇵' }, { code: '+82', flag: '🇰🇷' },
            { code: '+84', flag: '🇻🇳' }, { code: '+86', flag: '🇨🇳' },
            { code: '+90', flag: '🇹🇷' }, { code: '+91', flag: '🇮🇳' },
            { code: '+92', flag: '🇵🇰' }, { code: '+93', flag: '🇦🇫' },
            { code: '+94', flag: '🇱🇰' }, { code: '+95', flag: '🇲🇲' },
            { code: '+98', flag: '🇮🇷' }, { code: '+212', flag: '🇲🇦' },
            { code: '+213', flag: '🇩🇿' }, { code: '+216', flag: '🇹🇳' },
            { code: '+218', flag: '🇱🇾' }, { code: '+220', flag: '🇬🇲' },
            { code: '+221', flag: '🇸🇳' }, { code: '+222', flag: '🇲🇷' },
            { code: '+223', flag: '🇲🇱' }, { code: '+224', flag: '🇬🇳' },
            { code: '+225', flag: '🇨🇮' }, { code: '+226', flag: '🇧🇫' },
            { code: '+227', flag: '🇳🇪' }, { code: '+228', flag: '🇹🇬' },
            { code: '+229', flag: '🇧🇯' }, { code: '+230', flag: '🇲🇺' },
            { code: '+231', flag: '🇱🇷' }, { code: '+232', flag: '🇸🇱' },
            { code: '+233', flag: '🇬🇭' }, { code: '+234', flag: '🇳🇬' },
            { code: '+235', flag: '🇹🇩' }, { code: '+236', flag: '🇨🇫' },
            { code: '+237', flag: '🇨🇲' }, { code: '+238', flag: '🇨🇻' },
            { code: '+239', flag: '🇸🇹' }, { code: '+240', flag: '🇬🇶' },
            { code: '+241', flag: '🇬🇦' }, { code: '+242', flag: '🇨🇬' },
            { code: '+243', flag: '🇨🇩' }, { code: '+244', flag: '🇦🇴' },
            { code: '+245', flag: '🇬🇼' }, { code: '+246', flag: '🇮🇴' },
            { code: '+248', flag: '🇸🇨' }, { code: '+249', flag: '🇸🇩' },
            { code: '+250', flag: '🇷🇼' }, { code: '+251', flag: '🇪🇹' },
            { code: '+252', flag: '🇸🇴' }, { code: '+253', flag: '🇩🇯' },
            { code: '+254', flag: '🇰🇪' }, { code: '+255', flag: '🇹🇿' },
            { code: '+256', flag: '🇺🇬' }, { code: '+257', flag: '🇧🇮' },
            { code: '+258', flag: '🇲🇿' }, { code: '+260', flag: '🇿🇲' },
            { code: '+261', flag: '🇲🇬' }, { code: '+262', flag: '🇷🇪' },
            { code: '+263', flag: '🇿🇼' }, { code: '+264', flag: '🇳🇦' },
            { code: '+265', flag: '🇲🇼' }, { code: '+266', flag: '🇱🇸' },
            { code: '+267', flag: '🇧🇼' }, { code: '+268', flag: '🇸🇿' },
            { code: '+269', flag: '🇰🇲' }, { code: '+290', flag: '🇸🇭' },
            { code: '+291', flag: '🇪🇷' }, { code: '+297', flag: '🇦🇼' },
            { code: '+298', flag: '🇫🇴' }, { code: '+299', flag: '🇬🇱' },
            { code: '+350', flag: '🇬🇮' }, { code: '+351', flag: '🇵🇹' },
            { code: '+352', flag: '🇱🇺' }, { code: '+353', flag: '🇮🇪' },
            { code: '+354', flag: '🇮🇸' }, { code: '+355', flag: '🇦🇱' },
            { code: '+356', flag: '🇲🇹' }, { code: '+357', flag: '🇨🇾' },
            { code: '+358', flag: '🇫🇮' }, { code: '+359', flag: '🇧🇬' },
            { code: '+370', flag: '🇱🇹' }, { code: '+371', flag: '🇱🇻' },
            { code: '+372', flag: '🇪🇪' }, { code: '+373', flag: '🇲🇩' },
            { code: '+374', flag: '🇦🇲' }, { code: '+375', flag: '🇧🇾' },
            { code: '+376', flag: '🇦🇩' }, { code: '+377', flag: '🇲🇨' },
            { code: '+378', flag: '🇸🇲' }, { code: '+380', flag: '🇺🇦' },
            { code: '+381', flag: '🇷🇸' }, { code: '+382', flag: '🇲🇪' },
            { code: '+383', flag: '🇽🇰' }, { code: '+385', flag: '🇭🇷' },
            { code: '+386', flag: '🇸🇮' }, { code: '+387', flag: '🇧🇦' },
            { code: '+389', flag: '🇲🇰' }, { code: '+420', flag: '🇨🇿' },
            { code: '+421', flag: '🇸🇰' }, { code: '+423', flag: '🇱🇮' },
            { code: '+500', flag: '🇫🇰' }, { code: '+501', flag: '🇧🇿' },
            { code: '+502', flag: '🇬🇹' }, { code: '+503', flag: '🇸🇻' },
            { code: '+504', flag: '🇭🇳' }, { code: '+505', flag: '🇳🇮' },
            { code: '+506', flag: '🇨🇷' }, { code: '+507', flag: '🇵🇦' },
            { code: '+508', flag: '🇵🇲' }, { code: '+509', flag: '🇭🇹' },
            { code: '+590', flag: '🇬🇵' }, { code: '+591', flag: '🇧🇴' },
            { code: '+592', flag: '🇬🇾' }, { code: '+593', flag: '🇪🇨' },
            { code: '+594', flag: '🇬🇫' }, { code: '+595', flag: '🇵🇾' },
            { code: '+596', flag: '🇲🇶' }, { code: '+597', flag: '🇸🇷' },
            { code: '+598', flag: '🇺🇾' }, { code: '+599', flag: '🇨🇼' },
            { code: '+670', flag: '🇹🇱' }, { code: '+672', flag: '🇳🇫' },
            { code: '+673', flag: '🇧🇳' }, { code: '+674', flag: '🇳🇷' },
            { code: '+675', flag: '🇵🇬' }, { code: '+676', flag: '🇹🇴' },
            { code: '+677', flag: '🇸🇧' }, { code: '+678', flag: '🇻🇺' },
            { code: '+679', flag: '🇫🇯' }, { code: '+680', flag: '🇵🇼' },
            { code: '+681', flag: '🇼🇫' }, { code: '+682', flag: '🇨🇰' },
            { code: '+683', flag: '🇳🇺' }, { code: '+685', flag: '🇼🇸' },
            { code: '+686', flag: '🇰🇮' }, { code: '+687', flag: '🇳🇨' },
            { code: '+688', flag: '🇹🇻' }, { code: '+689', flag: '🇵🇫' },
            { code: '+690', flag: '🇹🇰' }, { code: '+691', flag: '🇫🇲' },
            { code: '+692', flag: '🇲🇭' }, { code: '+850', flag: '🇰🇵' },
            { code: '+852', flag: '🇭🇰' }, { code: '+853', flag: '🇲🇴' },
            { code: '+855', flag: '🇰🇭' }, { code: '+856', flag: '🇱🇦' },
            { code: '+880', flag: '🇧🇩' }, { code: '+886', flag: '🇹🇼' },
            { code: '+960', flag: '🇲🇻' }, { code: '+961', flag: '🇱🇧' },
            { code: '+962', flag: '🇯🇴' }, { code: '+963', flag: '🇸🇾' },
            { code: '+964', flag: '🇮🇶' }, { code: '+965', flag: '🇰🇼' },
            { code: '+966', flag: '🇸🇦' }, { code: '+967', flag: '🇾🇪' },
            { code: '+968', flag: '🇴🇲' }, { code: '+970', flag: '🇵🇸' },
            { code: '+971', flag: '🇦🇪' }, { code: '+972', flag: '🇮🇱' },
            { code: '+973', flag: '🇧🇭' }, { code: '+974', flag: '🇶🇦' },
            { code: '+975', flag: '🇧🇹' }, { code: '+976', flag: '🇲🇳' },
            { code: '+977', flag: '🇳🇵' }, { code: '+992', flag: '🇹🇯' },
            { code: '+993', flag: '🇹🇲' }, { code: '+994', flag: '🇦🇿' },
            { code: '+995', flag: '🇬🇪' }, { code: '+996', flag: '🇰🇬' },
            { code: '+998', flag: '🇺🇿' }
        ];
    }

    private buildCountryCodeTree() {
        this.countryCodeTree = {
            value: '+',
            children: new Map()
        };

        for (const country of this.allCountryCodes) {
            this.insertIntoTree(country);
        }
    }

    private insertIntoTree(country: { code: string; flag: string }) {
        let current = this.countryCodeTree;
        
        for (let i = 1; i < country.code.length; i++) {
            const digit = country.code[i];
            
            if (!current.children.has(digit)) {
                current.children.set(digit, {
                    value: country.code.substring(0, i + 1),
                    children: new Map()
                });
            }
            
            current = current.children.get(digit);
        }
        
        current.isCountryCode = true;
        current.countryData = country;
    }

    searchCountryCodes(prefix: string): { code: string; flag: string }[] {
        if (!prefix || prefix === '+') {
            return this.allCountryCodes;
        }

        const results: { code: string; flag: string }[] = [];
        let current = this.countryCodeTree;

        for (let i = 1; i < prefix.length; i++) {
            const digit = prefix[i];
            if (current.children.has(digit)) {
                current = current.children.get(digit);
            } else {
                return [];
            }
        }

        this.collectAllCodes(current, results);
        return results;
    }

    private collectAllCodes(node: CountryCodeNode, results: { code: string; flag: string }[]) {
        if (node.isCountryCode && node.countryData) {
            results.push(node.countryData);
        }

        for (const child of node.children.values()) {
            this.collectAllCodes(child, results);
        }
    }

    private async checkTwoFactorEnabled() {
        const host = (typeof window !== 'undefined' && window.location && window.location.hostname) ?
            window.location.hostname.toLowerCase() : '';
        const isNovaEnv = host.includes('nova');
        this.twoFaFeatureOn = isNovaEnv;
        if (isNovaEnv) {
            return;
        }
        try {
            this.feature.featureEnabled = this.feature.featureEnabled || {};
            await this.feature.register([twoFAFeatureId]);
            this.twoFaFeatureOn = !!this.feature.featureEnabled[twoFAFeatureId];
        } catch (e) {
            console.error('Failed to load feature flags', e);
            this.twoFaFeatureOn = false;
        }
    }

    ngOnDestroy() {
        // Clean up timer when component is destroyed
        if (this.verifyTimerInterval) {
            clearInterval(this.verifyTimerInterval);
        }
        if (this.otpStateSub) {
            this.otpStateSub.unsubscribe();
            this.otpStateSub = null;
        }
    }
}
